import { h, Component } from 'preact';
import {Form, I18n, FormEntry, Button} from 'components/elements'

import {connect} from 'react-redux'
import style from './index.less'
import {AccountActions} from 'actions'
import store from 'reducers'

@Form
@connect((state)=> state)
export default class ResetPrompt extends Component {
    constructor(props, context){
        super(props, context)
        this.state = {
            passwordError: false,
            resetError: false,
            resetSent: false,
            value: ''
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleResetPassword = this.handleResetPassword.bind(this)
    }
    handleResetPassword(){
        if(!this.state.value){
            this.setState({
                resetError: true
            })
        } else {
            AccountActions.resetPassword({
                authenticator: this.state.value, 
                url: location.protocol + '//' + location.host + location.pathname, 
                organizationID: this.props.organization.id,
                type: this.props.config.type || ''
            }).then((response)=>{
                this.setState({
                    resetSent: true
                })
            }).catch((e)=>{
                this.setState({
                    resetError: true
                })
            })
        }
    }
    handleChange(e){
        if(this.state.passwordError){
            this.setState({
                passwordError: false
            })
        }
        if(e.target.name == 'value'){
            this.setState({
                value: e.target.value,
                resetError: false
            })
        }
    }
    render(){
        const {Input, Form} = this.props
        return (
            <Form class={style.login} onSubmit={this.handleResetPassword}>
                <strong>
                  <I18n>enterYourEmailOrPhoneNumber</I18n>
                </strong>
                <br />
                <br />
                <Input onChange={this.handleChange} required={true} name='value' question='Email or Phone' type='text' types={['email', 'phone']} />
                <br />
                {this.state.resetSent ?
                <div class={style.resetSent}>An email or text has been sent with further instructions.</div>
                :
                <div class={style.resetPassword} onClick={this.props.handlePasswordResetPrompt}>Back to Log In</div>
                }
                <div class={style.errorSpacing}>
                    {this.state.resetError && 
                        <div class={style.errorMessage}>This email or phone number is incorrect.</div>
                    }
                </div>
                <Button>Reset Password</Button>
            </Form>
        )
    }
}



// WEBPACK FOOTER //
// ./components/partials/ResetPasswordPrompt/index.js